<template>
  <v-card outlined>
    <v-simple-table dense class="table-no-hover">
      <template #default>
        <tbody>
          <tr v-for="response in responses" :key="response.id">
            <td class="py-2" :class="response.type === 'USER' ? '' : 'blue lighten-4'">
              <div class="overline">
                {{ response.type === "USER" ? $t("responseList.user") : $t("responseList.auditor") }}
                {{
                  new Date(response.updatedAt).toLocaleString(undefined, {
                    timeZone: "CET",
                  })
                }}
              </div>

              <div>
                <Markdown :value="response.text" />
              </div>

              <div v-if="response.attachments.length" class="pt-2">
                <v-chip
                  v-for="attachment in response.attachments"
                  :key="attachment.id"
                  :href="attachment.file.url"
                  small
                  class="mr-1 mb-1"
                  target="_blank"
                  :close="removableFiles"
                  @click:close="$emit('remove-file', attachment.id)"
                >
                  {{ attachment.file.name }}
                </v-chip>
              </div>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
  </v-card>
</template>

<script>
export default {
  props: {
    responses: {
      type: Array,
      required: true,
    },

    removableFiles: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
